import {
  DropdownHeaderPropsBase,
  HeaderFactoryParams,
} from "@/components/common/dropdown/data/dropdown-button-data";
import { StaticImport } from "next/dist/shared/lib/get-img-props";
import Image from "next/image";
import headerStyles from "@/components/common/dropdown/styles/dropdown-header.module.scss";

interface DropdownHeaderWithIconProps extends DropdownHeaderPropsBase {
  icon: string | StaticImport;
  openedIcon: string | StaticImport;
}

const DropdownHeaderWithIcon = ({
  params,
  handleClick,
  icon,
  openedIcon,
}: DropdownHeaderWithIconProps) => {
  return (
    <Image
      className={headerStyles.header}
      ref={params.buttonRef}
      alt={"dropdown"}
      src={params.isOpen ? icon : openedIcon}
      onClick={
        handleClick ? handleClick : () => params.setIsOpen(!params.isOpen)
      }
    />
  );
};

export default DropdownHeaderWithIcon;
